import React from 'react';
import { ZendeskForm } from '@crescolabs/brand-common';
import { productTypeOptions } from '../zendesk/helpers';
import { themeObj } from '../theme';

export default function NewContactPage({ loading, isStaging }) {
  const Span = () => <span></span>;
  return (
    <ZendeskForm
      brandTheme={themeObj}
      loading={loading}
      isStaging={isStaging}
      ticketID={360005270154}
      apiBrand="Floracal"
      formBrand="Floracal"
      formTag="FloracalWebform"
      productTypeOptions={productTypeOptions}
      aboutProductSupportNode={Span}
    />
  );
}
